import { useMutation, useQueryClient } from '@tanstack/react-query';
import Notify from '@/components/Notification';
import { QUERY_KEYS } from '@/query/queryKeys';
import { getMessage } from '@/helpers/utils';
import { complaintService } from '../../services/complaintService';
import i18n from '@/i18n';

const { t } = i18n;

export const useCreateComplaint = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      complaintService
        .createComplaint(payload)
        .then(response => {
          const { status, data } = response;
          const message = getMessage(data);
          if (status === 201) {
            Notify.success({ text: t('kit:notify.complaint_submitted') });
            queryClient.refetchQueries({
              queryKey: [QUERY_KEYS.complaint.list],
            });
            return { data, success: true, message };
          }
          throw new Error(data?.message);
        })
        .catch(e => {
          return { success: false, message: e.message };
        }),
  });
};
